import dayjs from 'dayjs'
import { statusList } from './useStatusCheck'

export const getRevGeoData = async (siteDomain,lat,lon) => {
  const revGeoResponse = await fetch(`${siteDomain}/lba/revgeo?latlon=${lat}/${lon}`)
  const revGeoData = revGeoResponse.json()
  return revGeoData
}

export const getGpsData = () => {
  return new Promise((resolve, reject) => {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          resolve({ latitude, longitude })
        },
        (error) => {
          console.error('位置情報の取得に失敗しました', error);
          reject({ latitude: '', longitude: '' })
        }
      );
    } else {
      console.error('このブラウザは位置情報をサポートしていません。');
      reject({ latitude: '', longitude: '' })
    }
  });
};

export const makeResizedImageURL = (image_file) => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.src = URL.createObjectURL(image_file)
    let resizedImage = null
    image.onload = () => {
      const resizedImageBase64 = makeResizeImg(image);
      document.getElementById('thumbnail').src =resizedImageBase64
      const resizedImageBlob = base64ToBlob(resizedImageBase64)
      if(resizedImageBlob) resolve(resizedImageBlob)
      else reject(new Error('Failed'))
    }
  })
}

const makeResizeImg = (image) => {
  let newWidth = null
  let newHeight = null
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const MAX_SIZE = 1280
  if (image.width < MAX_SIZE && image.height < MAX_SIZE) {
    canvas.width = image.width
    canvas.height = image.height
    ctx.drawImage(image, 0, 0)
    return canvas.toDataURL('image/jpg')
  }

  if(image.width > image.height){
    newWidth = MAX_SIZE
    newHeight = MAX_SIZE * (image.height / image.width)
  } else {
    newHeight = MAX_SIZE
    newWidth = MAX_SIZE * (image.width / image.height)
  }

  canvas.width = newWidth
  canvas.height = newHeight
  ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, newWidth, newHeight)
  return canvas.toDataURL('image/jpg')
}

const base64ToBlob = (base64) => {
  const bin = atob(base64.replace(/^.*,/, ''))
  const buffer = new Uint8Array(bin.length).map((_, i) => bin.charCodeAt(i))
  const blob = new Blob([buffer.buffer], { type: 'image/jpg' })
  return blob
}

export const postImage = async (siteDomain,formData) => {
  try {
    const response = await fetch(`${siteDomain}/lbc/sakura_classification/v2`, {
      method: 'POST',
      body: formData
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const analyzedResult = await response.json()
    return analyzedResult
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error)
  }
}

export const postFeedBack = async (siteDomain,content) => {
  try {
    const akey = sessionStorage.getItem('akey') ? sessionStorage.getItem('akey') : wniutil.get_akey_v2()
    if(!sessionStorage.getItem('akey')) sessionStorage.setItem('akey', akey)
    content.append('akey', akey)
    const response = await fetch(`${siteDomain}/lbc/sakura_classification/feedback`, {
      method: 'POST',
      body: content
    })
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    } 
    return response
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error)
  }
}

export const getHistory = async (siteDomain,gvsDomain) => {
  try {
    const akey = sessionStorage.getItem('akey') ? sessionStorage.getItem('akey') : wniutil.get_akey_v2()
    if(!sessionStorage.getItem('akey')) sessionStorage.setItem('akey', akey)
    
    const response = await fetch(`${siteDomain}/lbc/sakura_classification/record?akey=${akey}`, {
      method: 'GET'
    })
    if (response.status !== 200) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const historyData = await response.json()
    const historyList = []
    for(const data of historyData['history']) {
      if (data.post_unixtime < 1767193199) continue // 2026年1月1日以降の解析結果のみ表示
      const postDate = dayjs(data.post_unixtime * 1000).format('M月D日')
      const postDateImgFormat = dayjs(data.post_unixtime * 1000).format('YYYY/MM/DD')
      const forecastDate = data.flowering_date ? `${Number(data.flowering_date.split('-')[1])}月${Number(data.flowering_date.split('-')[2])}日` : '解析不可'
      const mankaiForecastDate = data.mankai_date ? `${Number(data.mankai_date.split('-')[1])}月${Number(data.mankai_date.split('-')[2])}日` : '解析不可'
      const cityname = data.cityname ? data.cityname : '不明'
      const imgId = data.img_id
      const image = `${gvsDomain}/smart/report/sakura-classification/${postDateImgFormat}/${imgId}.jpg`
      const feedbackPosted = data.observation ? "1" : "0"
      const url = `/forecast/result/?cityname=${cityname}&kaikaDate=${data.flowering_date}&mankaiDate=${data.mankai_date}&predictionStatus=${data.prediction}&imageId=${imgId}&postDate=${postDateImgFormat}&feedback=${feedbackPosted}`
      historyList.push({
        postUnixTime: data.post_unixtime,
        postDate: postDate,
        forecastDate: forecastDate,
        mankaiForecastDate: mankaiForecastDate,
        observation: statusList[data.prediction],
        image: image,
        cityname: cityname,
        url: url
      })
    }
    historyList.sort((a, b) => ((a.postUnixTime > b.postUnixTime) ? -1 : 1));
    return historyList
  } catch (error) {
    console.error('There was a problem with the fetch operation:', error);
  }
}